import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import TemplateData from "utils/data/templateData/data";
import snack from "components/wrapper/snack";
import { Button } from "@mui/material";

export const ExcelDownloaderTemplate = (props: any) => {
  const download = () => {
   
    var data = props.onBeforeDownload();
    let header = [...TemplateData.product];
    const ws = XLSX.utils.book_new();
    const ws2 = XLSX.utils.json_to_sheet(TemplateData.Instructions);
    const ws3 = XLSX.utils.json_to_sheet(TemplateData.Example);

    XLSX.utils.sheet_add_aoa(ws, [header]);
    XLSX.utils.sheet_add_json(ws, data, { origin: "A2", skipHeader: true });
    // data sheet
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    // Instruction sheet
    XLSX.utils.book_append_sheet(wb, ws2, "Instructions");
    // Example sheet
    XLSX.utils.book_append_sheet(wb, ws3, "Example");

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });
    const finalData = new Blob([excelBuffer], { type: "xlsx" });
    FileSaver.saveAs(finalData, "paysfer-products.xlsx");
  };

  return (
    <>
      <Button
            size="small"
            style={{ backgroundColor: "rgb(48,79,49)" }}
            onClick={download}
            variant="contained"
            color="primary"
          >
        Download All Products
      </Button>
    </>
  );
};
